var exports = {
  "$n": "FacetOption__svrHPt",
  "F1": "TrailingAction__Y0uueX",
  "$S": "TruncateWrap__BAVmTu",
};

module.exports = exports;
